import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { MyEInvoiceTinUpdateRequestLineContainerModel } from '../../../../../models/aggregates/e-invoice/my_einvoice_tin_update_request_line_container.model';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceTinUpdateRequestLineService extends BaseApiPublicLoginTemplateService<MyEInvoiceTinUpdateRequestLineContainerModel, MyEInvoiceTinUpdateRequestLineContainerModel, MyEInvoiceTinUpdateRequestLineContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-lines'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-lines/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-lines/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-lines/' + BaseApiTemplateService.LOGIN_EP
    this.httpClient = http;
  }

}
